import { getEnv, getMockAddress } from "#/utils/getEnv";

export const APPLICATION = {
  ID: process.env.REACT_APP_ID.replace(/-/g, "_"),
  NAME: `@${process.env.REACT_APP_ID.replace(/-/g, "_").toUpperCase()}`,
  EXTERNAL: ["WEB_CRM", "WEB_PUBLIC"].includes(
    process.env.REACT_APP_JOB_TEMPLATE_TYPE
  ),
  get BFF_URL() {
    const env = getEnv();
    if (env === "mock") {
      return getMockAddress();
    }

    return window.env?.KONG;
  },

  get BFF_URL_SECCORP() {
    return window.env?.BFF_URL_SECCORP;
  },

  get ENV() {
    return window.env?.ENV;
  },
};

export const PAGE = {
  ROOT: () => "/",
  FAQ: () => "/duvidas-frequentes",
  CART: () => `/carrinho`,
  PAYMENT: (pixid: string) => `/pagamento/${pixid}`,
  BENEFITS_PARTNER: () => "/sobre-o-parcerias-e-descontos",
  PARTNER: () => `/parceiro`,
  PARTNERS_SHOWCASE: () => `/vitrine-de-parceiros`,
  RV_REFILL_PHONE: () => `/recarga-de-celular`,
  RV_REFILL_PHONE_VALUES: () => `/recarga-de-celular-valores/`,
  RV_REFILL_TV: (provider: string) => `/opcoes-tv/${provider}`,
  RV_REFILL_TV_CONFIRM: (provider: string, productId: string) =>
    `/opcoes-tv/${provider}/${productId}`,
  RV_REFILL_PIN: (provider: string) => `/opcoes-pin/${provider}`,
  RV_REFILL_PIN_CONFIRM: (provider: string, productId: string) =>
    `/opcoes-pin/${provider}/${productId}`,
  CATEGORIES: () => "/categorias",
  MY_ORDERS: () => `/meus-pedidos`,
  MY_ORDERS_DETAILS: (orderNumber: string) =>
    `/meus-pedidos/detalhes/${orderNumber}`,
  RECHARGES: () => "/recargas-e-giftcard",
  ERROR: (local: string) => `/erro/${local}`,
  SUCCESS: (local: string) => `/sucesso/${local}`,
};

export const ERROR_MESSAGES = {
  FORBIDDEN: (action?: string) => ({
    title: "Acesso não autorizado.",
    children: `Você não possui permissão para realizar esse acesso.`,
    secondaryButton: undefined,
  }),
  UNAVAILABLE: (title?: string) => ({
    title: title ?? "Serviço indisponível.",
    children: `Estamos passando por instabilidades no sistema. Tente novamemte em alguns instantes.`,
  }),
  NOT_FOUND: (title?: string, children?: string) => ({
    title: title ?? "Registro não encontrado.",
    children: children ?? `Não identificamos o item solicitado.`,
  }),
  REQUIRED: () => "Campo obrigatório.",
};
